import * as serviceContext from '../services/serviceContext';
import { REPORTS_ROOT as ReportsURL, BASE_IMAGE_PATH_NEW } from '../configs/api';

var options = {};
var headers = new Headers();
// let userData = JSON.parse(localStorage.getItem("tokenData"))

headers.append('Content-Type', 'application/json');
options.headers = headers;

export async function getMarquee() {
    try {
        const response = await serviceContext.get("marketprovider/marquee", null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

// export async function getIpdata() {
//     return new Promise((resolve, reject) => {
//         fetch("https://geolocation-db.com/json/")
//             .then((response) => response)
//             .then((res) => {
//                 resolve(res);
//             })
//     })
// }

// export async function getClientIp() {
//     try {
//         const response = await getIpdata();
//         if (response.hasError === true) {
//             return false;
//         }
//         else {
//             const res = response.json();
//             return res;
//         }
//     }
//     catch (error) {
//         return error;
//     }
// }

export async function getClientIPOwnApi() {
    try {
        const response = await serviceContext.get("marketprovider/device/info", null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function checkMaintainanceCall() {
    
    try {
        const response = await serviceContext.get(`${ReportsURL}maintenance`, null , options); //+"transactions", JSON.stringify(data), options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getSplashPopupListJson() {
    return new Promise((resolve, reject) => {
        fetch(`${BASE_IMAGE_PATH_NEW}/splashpopup/splashpopuplist.json`) 
            .then((response) => response.json())
            .then((res) => {
                resolve(res)
            })
    })

    // return res;

}